export default __webpack_public_path__ + "static/media/promos-icon-active.544dee71.webp";